/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { RootState } from '../../store'


/** Returns all ADAS Programs */
export const selectPrograms = (state: RootState) => state.adasPrograms.programs

/** Returns a specific ADAS Program */
export const selectProgram = (state: RootState, adasProgramId: string) => state.adasPrograms.programs.find(program => program.id === adasProgramId)
